/* global window */
'use strict';

import Domodule from 'domodule';

class ContentFilter extends Domodule {
  filter(el, event, options) {
    event.preventDefault();

    const filters = (this.options.currentFilter.length) ? this.options.currentFilter.split(',') : [];
    const index = filters.indexOf(options.slug);

    if (index !== -1) {
      filters.splice(index, 1);
    } else {
      filters.push(options.slug);
    }

    const url = `${el.getAttribute('href')}&type=${filters.join(',')}`;
    window.location = url;
  }
}

Domodule.register('ContentFilter', ContentFilter);
